import ApiService from './ApiService';

export default class ActivationCodeService {
  /**
   * Applies an activation code from Editage
   * @param {string} activationCode - Code to activate
   * @returns {Promise} API response
   */
  static applyCodeAtivationFroEditage(activationCode) {
    return ApiService.post('/activation-code/apply-coupon-from-editage', { activationCode });
  }
}
